export interface SmushResponse {
    directLink: string;
    torrentLink: string;
}
